export const APP_URLS = {
  HOME: '/home',
  SEARCH: '/search',
  LOGIN: '/login',
  REGISTER: '/register',
  SCHOOL: '/school',
  FORGOT_PASSWORD: '/forgot-password',
  FORM: '/form',
  HELP: '/help',
  DIHOME: '/scoresendcodehome',
  DISEARCH: '/scoresendcodesearch',
  DIFORM:'/diform',
  DIUPDATEFORM: '/diupdateform'
};
